import baseApi from "./baseApi";

export default {
    async getPlantData() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/nupointspray/plants");

        return result.data;
    },

    async getNuPointSprayJob(jobID) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/nupointspray/jobs/${jobID}`);

        return result.data;
    },

    async searchNuPointSprayJobs(plantIDs, startDate, endDate) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/nupointspray/jobs?${[
            `plantIDs=${plantIDs.join(",")}`,
            `fromDate=${startDate}`,
            `toDate=${endDate}`
        ].join("&")}`);

        return result.data;
    },

    async deleteJobs(jobIDs) {
        let request = await baseApi.createHttpRequest();
        let result = await request.delete(`/nupointspray/jobs?${[
            `jobIDs=${jobIDs.join(",")}`
        ].join("&")}`);

        return result.data;
    },
    
    async getNuPointSprayJobStatuses() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/nupointspray/jobstatuses");

        return result.data;
    },

    async updateNuPointSprayJob(jobID, job) {
        let request = await baseApi.createHttpRequest();
        let result = await request.put(`/nupointspray/jobs/${jobID}`, job);

        return result.data;
    }
}